import {
  ETAEvaluationPrecedenceBlock,
  ETAEvaluationPrecedenceContainer,
  ETAEvaluationList,
  HeaderText
} from "../common/ETANotificationConfigs.style";
import {
  DragDropContext,
  Draggable,
  DraggableProvided,
  DraggableStateSnapshot,
  Droppable,
  DroppableProvided
} from "react-beautiful-dnd";
import {useState} from "react";
import {ETAEvaluationItem} from "./ETAEvaluationItem";
import {useETANotificationContext} from "../ETANotificationConfigsProvider";
import {Tooltip} from "@blueprintjs/core";
import {InformationIcon} from "../../../../common/icons";

const getItemStyle = (isDragging: boolean, draggableStyle: any) => {
  const commonStyles = {
    ...draggableStyle
  };
  let additionalStyles;
  if (!isDragging) {
    additionalStyles = {
      background: "#fff",
      border: "1px dashed rgba(0,0,0,0)"
    };
  } else {
    additionalStyles = {
      background: " rgba(244, 245, 247, 0.5)",
      border: "1px dashed #CBD0DF"
    };
  }

  return {...commonStyles, ...additionalStyles};
};

export const ETAEvaluationPrecedence = () => {
  const {includeOptimizationETAEnabled, evaluationState, onDragEnd, onEdit} = useETANotificationContext();
  const [expandedState, setExpandedState] = useState<{[key: string]: boolean}>({});

  const handleToggleCollapse = (name: string) => {
    setExpandedState((prev) => ({
      ...prev,
      [name]: !prev[name]
    }));
  };

  const handleDragEnd = (result: any) => {
    void onDragEnd(result);
  };

  return (
    <ETAEvaluationPrecedenceContainer>
      <ETAEvaluationPrecedenceBlock>
        <div style={{display: "flex", alignItems: "center", gap: "8px"}}>
          <HeaderText>Evaluation Precedence</HeaderText>
          <Tooltip
            content={
              <div>
                <p>
                  Sometimes, a stop will match multiple logics. If you have a one-size-fits all logic, and then also a
                  logic for a certain customer or service type, we&apos;d suggest putting the specific one at higher
                  rank. Our system will automatically follow the highest ranked argument if a stop matches multiple
                  arguments.
                </p>
              </div>
            }
            placement="top"
            popoverClassName="content-tooltip"
          >
            <div data-testid="evaluation-precedence-information-icon" style={{display: "flex", alignItems: "center"}}>
              <InformationIcon scale={0.8} />
            </div>
          </Tooltip>
        </div>
        <ETAEvaluationList>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="droppable">
              {(provided: DroppableProvided) => {
                return (
                  <div style={{flexGrow: 1}} {...provided.droppableProps} ref={provided.innerRef}>
                    {evaluationState.data.map((item, index) => (
                      <Draggable key={item.id} draggableId={item.id as string} index={index}>
                        {(provided: DraggableProvided, snapshot: DraggableStateSnapshot) => {
                          return (
                            <div
                              ref={provided.innerRef}
                              style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                              {...provided.draggableProps}
                            >
                              <ETAEvaluationItem
                                item={item}
                                rank={item.rank || index + 1}
                                isExpanded={expandedState[item.id || ""] || false}
                                onToggleCollapse={() => handleToggleCollapse(item.id || "")}
                                onEdit={() => onEdit(item)}
                                dragProps={{...provided.dragHandleProps}}
                                includeOptimizationETA={includeOptimizationETAEnabled}
                              />
                            </div>
                          );
                        }}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                );
              }}
            </Droppable>
          </DragDropContext>
        </ETAEvaluationList>
      </ETAEvaluationPrecedenceBlock>
    </ETAEvaluationPrecedenceContainer>
  );
};
